import {memo} from 'react';

import styled from 'styled-components';

import SocialNetworks from '~/shared/components/PageFooter/10bis/FooterSection/SocialNetworks';
import {media} from '~/shared/theme/media';
import {googlePlayLink, iTunesLink} from '~/shared/config';

import FooterLogo from '../assets/footerLogo.svg?react';
import FooterDownloadTheApp from '../../shared/FooterDownloadTheApp';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  padding: 40px 0 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  ${media.minLargeMobile`
    flex-direction: row;
    align-items: flex-start;
  `}
`;

const LogoContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;

type FooterTopSectionProps = {
  isIOS?: boolean;
  isAndroid?: boolean;
};

const FooterTopSection = ({isAndroid, isIOS}: FooterTopSectionProps) => {
  return (
    <Root>
      <LogoContainer>
        <FooterLogo />
      </LogoContainer>
      <SocialNetworks />
      <FooterDownloadTheApp isIOS={isIOS} isAndroid={isAndroid} iosLink={iTunesLink} androidLink={googlePlayLink} />
    </Root>
  );
};

export default memo(FooterTopSection);
